module.exports = __webpack_public_path__ + "img/e495648.jpg";